module.exports = __webpack_public_path__ + "bv.svg?89490dfe6089d40803e9b48427ccc82d";